<template>
  <!-- HOME TEAM FORM -->
  <div class="szw-flex szw-gap-2 szw-flex-1">
    <div :class="teamFormItemClasses" v-for="shadowEvent in props.eventsNumber" :key="shadowEvent">
      <div :class="['szw-row__center szw-text-sm szw-rounded szw-w-5 szw-h-5', 'szw-bg-section-static szw-animate-pulse']"></div>
      <div :class="['szw-h-5 szw-w-5 szw-rounded-full', 'szw-bg-section-static szw-animate-pulse']"></div>
    </div>
  </div>

  <!-- LABEL & DIVIDERS -->
  <div class="szw-flex szw-flex-row szw-text-xs szw-items-center szw-justify-center szw-gap-2 szw-flex-1">
    <div :class="['szw-flex szw-flex-col szw-items-center szw-justify-center szw-h-14 szw-gap-1', { 'szw-mx-4': !props.isSmallWidgetContainerSize }]">
      <div :class="['szw-w-16 szw-h-4', 'szw-bg-section-static szw-animate-pulse']"></div>
      <div :class="['szw-w-16 szw-h-4 szw-rounded', 'szw-bg-section-static szw-animate-pulse']" />
    </div>
  </div>

  <!-- AWAY TEAM FORM -->
  <div class="szw-flex szw-gap-2 szw-flex-1">
    <div :class="teamFormItemClasses" v-for="shadowEvent in props.eventsNumber" :key="shadowEvent">
      <div :class="['szw-row__center szw-text-sm szw-rounded szw-w-5 szw-h-5', 'szw-bg-section-static szw-animate-pulse']"></div>
      <div :class="['szw-h-5 szw-w-5 szw-rounded-full', 'szw-bg-section-static szw-animate-pulse']"></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  isSmallWidgetContainerSize: {
    type: Boolean,
    default: false
  },
  eventsNumber: {
    type: Number,
    default: 5
  }
})

const baseClasses = ['szw-col szw-items-center first:szw-ml-auto last:szw-mr-auto']
const teamFormItemClasses = computed(() => [...baseClasses, props.isSmallWidgetContainerSize ? 'szw-gap-2' : 'szw-gap-4'])
</script>
